import { useLayoutEffect, useRef, useState } from 'react';
import _ from 'lodash';

const useContentDimensions = containerRef => {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(300);

  const refDefault = useRef({});

  const ref = containerRef || refDefault;

  const currentRef = ref.current || refDefault.current;

  useLayoutEffect(() => {
    const handleResize = () => {
      setHeight(currentRef.offsetHeight);
      setWidth(currentRef.offsetWidth);
    };

    handleResize();
    window.addEventListener('resize', _.debounce(handleResize, 150));

    return function cleanUpListener() {
      window.removeEventListener('resize', handleResize);
    };
  }, [currentRef]);

  return {
    height,
    width
  };
};

export default useContentDimensions;
